import { Component, Input, CUSTOM_ELEMENTS_SCHEMA, OnInit } from '@angular/core';
import { FormGroup, FormControl, AbstractControl, ReactiveFormsModule } from '@angular/forms';

import '@maersk-global/mds-components-core/mc-input';
import '@maersk-global/mds-components-core/mc-select';
import '@maersk-global/mds-components-core/mc-typeahead';
import { IMcTypeaheadData } from '@maersk-global/mds-components-core/mc-typeahead/types';
import { CodeDescription } from '../../../models/code-description.model';

@Component({
  selector: 'app-create-damage-code-header',
  standalone: true,
  imports: [ReactiveFormsModule],
  templateUrl: './create-damage-code-header.component.html',
  styleUrls: ['./create-damage-code-header.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CreateDamageCodeHeaderComponent implements OnInit {
  @Input() formGroup!: FormGroup;

  // source data (code/description) used elsewhere
  damageTypeList: CodeDescription[] = [
    { code: '0', description: '0 - Structural' },
    { code: '1', description: '1 - ReeferUnit' },
    { code: '2', description: '2 - Genset' },
  ];

  // mc-typeahead expects items with `label` and `value` properties
  damageTypeOptions: IMcTypeaheadData[] = [];

  ngOnInit(): void {
    // prepare typeahead-friendly data
    this.damageTypeOptions = (this.damageTypeList || []).map((d) => ({ label: d.description || d.code || '', value: d.code || '' }));
  }

  onDamageTypeSelected(event: any): void {
    // The UI option labels are like "0 - Structural" but the API and routes need the numeric code (0). This handler strips the label and keeps only the numeric part.
    const custom = event as CustomEvent<{ value?: string | number }>;
    const rawValue = custom?.detail?.value ?? (event.target as HTMLInputElement | null)?.value ?? '';
    const s = String(rawValue ?? '');
    const m = /(\d+)/.exec(s);
    const code = m ? m[0] : s;
    this.formGroup.get('damageType')?.setValue(code);
  }

  isControlInErrorState(control: FormControl | AbstractControl | null | undefined): boolean | null {
    if (control?.invalid && control.touched) {
      return true;
    }
    return null;
  }
}
